export const constFlag = {
  pageMain: "pageMain",
  pageMyProject: "pageMyProject",
  pageProjectDetail: "pageProjectDetail",
};
